<template>
  <div class="v-sidebar-menu" :class="[!isCollapsed ? 'vsm-default' : 'vsm-collapsed']" :style="{'width': sidebarWidth, 'display': ((isMobile && btnHiddenMenu) ? 'none' : 'block')}" @mouseleave="mouseLeave">
    
    <div class="vsm-list scrollbar-custom" style="padding-bottom: 60px;" :style="[{'height' : '100%', 'margin-top': '50px', 'overflow-y': !isCollapsed ? 'auto' : 'initial'}]">
      <template v-for="(item, index) in menu">
         <template v-if="item.header && item.tipoUser.includes(parseInt($store.state.user.tipo)) || item.tipoUser.length == 0">
           <div v-if="!isCollapsed" :key="index" class="vsm-header">{{item.title}}</div>
           <item v-if="isCollapsed && item.tipoUser.includes(parseInt($store.state.user.tipo)) || item.tipoUser.length == 0" :key="index" :item="item" :firstItem="true" :isCollapsed="isCollapsed"/>
         </template>
         <item v-else-if="!isCollapsed && item.tipoUser.includes(parseInt($store.state.user.tipo)) || item.tipoUser.length == 0" :key="index" :item="item" :firstItem="true" :isCollapsed="isCollapsed"/>
      </template>
    </div>
    <div v-if="isCollapsed" :style="[{'position' : 'absolute'}, {'top' : '50px'}, {'left' : '50px'}, {'z-index' : 30}, {'width' : '240px'}]" class="vsm-list">
      <div v-for="(item, index) in mobileItems" :key="index">
        <!-- <mobile-item :item="item" :key="index"/> -->
        <item v-if="isCollapsed && item.tipoUser.includes(parseInt($store.state.user.tipo)) || item.tipoUser.length == 0" :key="index" :item="item" :style="[{'margin-left' : '14px'}]" />
        <transition name="slide-animation">
          <div class="vsm-mobile-bg scrollbar-custom" v-if="item" :style="[{'position' : 'absolute'}, {'left' : '12px'}, {'right' : '0px'}, {'top' : '0px'}, {'height' : '1200px'}, {'overflow-y': 'auto'}]"></div>
        </transition>
        <!-- <div class="vsm-dropdown" :style="[{'position' : 'absolute'}, {'top' : `${mobileItemHeight}px`}, {'left' : '10px'}, {'right' : '0px'}, {'max-height' : `800px`}, {'overflow-y' : 'auto'}, {'width' : '220px'}]">
          <transition name="show-animation">
            <div class="vsm-list" v-if="item && item.child">
              <sub-item v-for="(subItem, index) in item.child" :item="subItem" :key="index"/>
            </div>
          </transition>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Item from './Item.vue'
import SubItem from './SubItem.vue';
import MobileItem from './MobileItem.vue';

export default {
  name: 'SidebarMenu',
  props: {
    menu: {
      type: Array,
      required: true
    },
    btnCollapsed: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: false
    },
    btnHiddenMenu: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '240px'
    },
    widthCollapsed: {
      type: String,
      default: '64px'
    }
  },
  data() {
    return {
      temp: '',
      sidebarWidth: this.collapsed ? this.widthCollapsed : this.width,
      isCollapsed: this.collapsed,
      isMobile: this.mobile,
      mobileItems: null,
      mobileItemPos: 0,
      mobileItemHeight: 0,
      closeTimeout: null,
    }
  },
  created() {
    this.checkCollapse();

    this.$on('mouseEnterItem', (val) => {
      // this.mobileItem = val.item
      // this.mobileItemPos = val.pos
      // this.mobileItemHeight = val.height
    })

    this.$on('clickItem', () => {
      console.log('click');
      if (this.closeTimeout) clearTimeout(this.closeTimeout)
      this.closeTimeout = setTimeout(() => {
        this.mouseLeave()
      }, 600)
    })

    this.$on('showMenu', (val) => {
      this.mobileItems = val.item.items
      this.mobileItemPos = val.pos
      this.mobileItemHeight = val.height
    })

    this.$on('showSubItems', (val) => {
      this
    })
    
    window.addEventListener("resize", () => {
      this.checkCollapse();      
    });

  },
  methods: {
    mouseLeave() {
      this.mobileItems = null;
      this.itemSelected = false;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
      this.sidebarWidth = this.isCollapsed ? this.widthCollapsed : this.width
      this.$emit('collapse', this.isCollapsed)
    },
    checkCollapse() {

      if(window.innerWidth <= 1200){

        this.isMobile = true;
        this.$emit('mobile', true);
      
      }else{
        this.isMobile = false;
        this.$emit('mobile', false);

      }

      this.isCollapsed = true;
      this.sidebarWidth = this.isCollapsed ? this.widthCollapsed : this.width
      this.$emit('collapse', this.isCollapsed)

    }
  },
  watch: {
      btnCollapsed: {
          immediate: true,
          handler (value) {
            this.toggleCollapse();
          }
      },
  },
  components: {
    Item,
    SubItem,
    MobileItem
  }
}
</script>
